import { FormattedNumber } from 'react-intl';

import { Typography, TypographyProps } from '@mui/material';

import { NumberFormatOptions } from '@formatjs/ecma402-abstract';

export interface OfferingDetailValueProps {
  value: number;
  typographyProps?: TypographyProps;
  formattedNumberProps?: NumberFormatOptions;
}

export const OfferingDetailValue = ({ value, formattedNumberProps, typographyProps }: OfferingDetailValueProps) => {
  return (
    <Typography variant="body1.semibold" {...typographyProps}>
      <FormattedNumber value={value} maximumFractionDigits={0} minimumFractionDigits={0} {...formattedNumberProps} />
    </Typography>
  );
};

export const OfferingDetailMonetaryValue = ({ formattedNumberProps, ...rest }: OfferingDetailValueProps) => {
  return (
    <OfferingDetailValue
      formattedNumberProps={{ style: 'currency', currency: 'USD', ...formattedNumberProps }}
      {...rest}
    />
  );
};
